// AI Generated Component
import { Component, Input, OnInit } from '@angular/core';
import { PageRepoService } from '@client/app/services/api/page-repo/page-repo.service';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'page-details-section-inventory-metadata',
    standalone: false,
    template: `
        <div class="d-flex align-items-center mb-2">
            <span class="fa-2x fa-fw mr-2 text-link mt-1 fas fa-info" aria-hidden="true"></span>
            <div>
                <h2 class="font-weight-300 mb-0" translate>
                    Metadata
                </h2>
                <span class="text-grey" translate [translate-n]="data.total" translate-plural="[[$count]] found">
                    1 found
                </span>
            </div>
        </div>
        <mon-tabs [showSearch]="false"
                  [options]="[]"
                  (onSearch)="onSearch($event)"
                  [search]="search"
                  [minSearchLength]="1">
        </mon-tabs>
        <div class="card panel-monsido-card">
            <div class="card-body">
                <table-container
                        [noResultMessage]="'Good job! No issues were found' | translate"
                        [collection]="data"
                        (onPageChange)="onPageChange($event)"
                        (onPerPageChange)="onPageSizeChange($event)"
                        [progress]="promise">
                    <table class="table table-hover table-vertial-align">
                        <thead>
                        <tr>
                            <th class="col-20">
                                <span class="inline-block outer-l-medium" translate>
                                    META name/property
                                </span>
                            </th>
                            <th class="col-28">
                                <span class="inline-block outer-r-medium" translate>
                                    META content
                                </span>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let meta of data">
                            <td class="text-ellipsis">
                                <span class="inline-block outer-l-medium">
                                    {{meta.key}}
                                </span>
                            </td>
                            <td>
                                <span class="inline-block outer-r-medium">
                                    {{ meta.value }}
                                </span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </table-container>
            </div>
        </div>
    `,
})
export class PageDetailsSectionInventoryMetadataComponent extends BaseContainerComponentController implements OnInit {
    @Input() pageObj: any;

    data: any = [];
    promise: any;
    selected: any = [];

    constructor (private pageRepoService: PageRepoService) {
        super({ table: true });
    }

    ngOnInit (): void {
        this.pageObj = this.pageObj || {};
        this.data = [];
        this.search = '';

        this.getPage = this.getPageFunction.bind(this);
        this.getPage();
    }

    getPageFunction (): void {
        this.selected = [];
        const params: any = {
            type: 'meta',
            page_size: this.pageSize,
            page: this.page,
            search: this.search,
        };

        this.promise = this.pageRepoService.getMetadata(this.pageObj.id, params).then((data: any) => {
            this.data = data;
        });
    }

    trackByIndex (index: number): number {
        return index;
    }
}
